import React, { useState , useEffect } from 'react';
import { Link } from 'react-router-dom';
import swal from 'sweetalert';

const Contact = (props)=>  {


    useEffect(() => {
        window.scrollTo(0, 0)

    }, []);




        return (
            <div>
                <div className="bg-light py-3">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12 mb-0"><Link to="/">Home</Link> <span className="mx-2 mb-0">/</span> <strong className="text-black">Privacy Policy</strong></div>
                        </div>
                    </div>
                </div>
                <div className="container" style={{width : "99% " ,padding : "30px 30px"}}>
                        <div className="row">
                            <div className="col-xl-12 col-lg-12 col-md-12">
                                <div style={{fontWeight :"bold"}}>
                                {/* <h2>This Privacy Policy</h2> */}
                                <h1>Privacy Policy</h1>
    <p>
        MALOOK is committed to ensuring that your personal information is kept secure at all times. This Privacy Policy explains how we will collect and use your personal information through our website <a href="http://www.DubaiPlantStore.com">www.DubaiPlantStore.com</a>. Please read our Privacy Policy carefully to get a clear understanding of how we collect, use, protect, or otherwise handle your personal information. We do not and will not sell or redistribute your information to anyone.
    </p>

    <h2>What personal information do we collect from the people that visit our website?</h2>
    <p>
        When ordering or registering on our site, you may be asked to enter your name, email address, contact number, mailing address, credit card information, or other details to help you with your experience.
    </p>

    <h2>When do we collect information?</h2>
    <p>
        We collect information from you when you register on our website, place an order, subscribe to updates, leave a message on Customer Service, or enter information on our website.
    </p>

    <h2>Use and storage of your personal information</h2>
    <p>
        We may use the information we collect from you in the following ways:
    </p>
    <ul>
        <li>To be able to contact you in the event of any problem with the delivery of your items.</li>
        <li>To process orders and to send information and updates pertaining to orders.</li>
        <li>To be able to send text message notifications of delivery status.</li>
        <li>To personalize your experience and to allow us to deliver the type of content and product offerings in which you are most interested.</li>
        <li>To allow us to better service you in responding to your customer service requests.</li>
        <li>To quickly process your transactions.</li>
        <li>To ask for ratings and reviews of services or products.</li>
    </ul>
    <p>
        We will only keep your information for as long as necessary to carry out our services to you or for as long as we are required by law. After this, your personal information will be deleted. Rest assured, your personal information is protected by an additional security layer called SSL, which ensures your sensitive information is transmitted securely through an encrypted link.
    </p>

    <h2>Cookies</h2>
    <p>
        We also use non-personal data such as third-party cookies to collect statistics to enhance and simplify your visit. A cookie is a piece of information that is held on the hard drive of your computer which records how you have used a website. Cookies make it easier for you to log on and use the website during future visits.
    </p>
    <p>
        The permanent cookies are stored on your computer or mobile device for no longer than 24 months. You can easily erase cookies from your computer or mobile device using your browser.
    </p>

    <h2>Your Rights</h2>
    <p>
        You have the right to request information about the personal data we hold on you. If your data is incorrect, incomplete, or irrelevant, you can ask to have the information corrected or removed.
    </p>

    <div class="note">
        <strong>Note:</strong> Please contact us if you have any questions or concerns regarding your personal information.
    </div>
                                </div>
                            </div>
                        </div>
                </div>
            </div>
        )
    
}


export default Contact;